import type { ReactNode } from 'react';
import { AnchoredPopover as SharedAnchoredPopover, type MenuAnchor } from '@/components/shared';

// Menu-Slot chrome; protocol-ui re-applies tokens in the Radix portal; the ring is the edge.
export const MENU_CONTENT_CLASS =
  'protocol-ui protocol-scroll flex w-auto max-h-[var(--radix-popover-content-available-height)] flex-col items-center border-0 gap-1.5 overflow-y-auto rounded-2xl bg-[var(--surface-overlay)] px-1.5 py-2.5 shadow-[inset_0_0_0_1px_var(--border-subtle),0px_3px_12px_0px_var(--shadow-sm)] backdrop-blur-[6px]';

// Shared anchored popover; keepFocus because these float over the editor's caret.
export function AnchoredPopover({ anchor, onClose, children }: { anchor: MenuAnchor; onClose: () => void; children: ReactNode }) {
  return (
    <SharedAnchoredPopover anchor={anchor} onClose={onClose} className={MENU_CONTENT_CLASS} keepFocus>
      {children}
    </SharedAnchoredPopover>
  );
}
